import { Form, Formik, FormikHelpers } from "formik";
import { Button, Stack } from "native-base";
import React, { useCallback } from "react";
import { object, string } from "yup";
import { formikErrorMessages } from "../../../helper/formik-helper";
import FormikTextFormInput from "../../form/FormikTextFormInput";
import { getBackendURL } from "../../../environment";
import { useParams } from "react-router-dom";

const initialValues = {
  eMail: "",
};

type FormValues = typeof initialValues;

const validationSchema = object().shape({
  eMail: string()
    .required(formikErrorMessages.required)
    .email(formikErrorMessages.eMail),
});

type Props = {
  code: string;
  afterArchiveRequested: () => void;
};

export default function RequestAllObjectsArchiveForm({
  code,
  afterArchiveRequested,
}: Props) {
  const { projectOrObjectId } = useParams();

  const onSubmit = useCallback(
    async (values: FormValues, formikHelpers: FormikHelpers<FormValues>) => {
      const { eMail } = values;
      const { setSubmitting } = formikHelpers;

      await fetch(`${getBackendURL()}/archive/project`, {
        method: "POST",
        headers: {
          Accept: "application/json",
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          projectOrObjectId,
          code,
          recipient: eMail,
        }),
      });

      setSubmitting(false);
      afterArchiveRequested();
    },
    [projectOrObjectId, afterArchiveRequested]
  );

  return (
    <div>
      <p>
        Sie können ZIP-Archive aller Fotos aller Objekte anfordern. Sie erhalten
        die Download-Links in ca. einer Stunde per E-Mail.
      </p>

      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={onSubmit}
      >
        {({ submitForm, isSubmitting }) => (
          <Form>
            <Stack space={2}>
              <FormikTextFormInput fieldPath="eMail" label="E-Mail" />

              <Button
                mt={4}
                onPress={submitForm}
                isLoading={isSubmitting}
                isDisabled={isSubmitting}
              >
                Download-Links anfordern
              </Button>
            </Stack>
          </Form>
        )}
      </Formik>
    </div>
  );
}
